import React, { useMemo } from "react";
import { Grid, MultiSelect, Group, Button, Text } from "@mantine/core";
import {
  FUND_FILTER_COLUMNS,
  buildFundDistinctValues,
} from "../helpers/approvalFundListFundsUtils";

const getFilterValues = (tableFilterQuery, field) =>
  tableFilterQuery[field]?.$in ?? [];

const OrderArFormFundFilters = ({
  funds,
  tableFilterQuery,
  onFilterChange,
  filteredCount,
  totalCount,
}) => {
  const filterOptions = useMemo(
    () =>
      FUND_FILTER_COLUMNS.map((col) => ({
        col,
        field: col.filter.field,
        label: col.filter.label,
        data: buildFundDistinctValues(funds, col),
      })),
    [funds]
  );

  const hasActiveFilters = Object.keys(tableFilterQuery).length > 0;

  return (
    <div>
      <Grid gutter="md" mb="sm">
        {filterOptions.map(({ field, label, data }) => (
          <Grid.Col key={field} span={12} sm={6} lg={4}>
            <MultiSelect
              label={label}
              placeholder="All"
              data={data}
              value={getFilterValues(tableFilterQuery, field)}
              onChange={(values) => onFilterChange(field, values, data)}
              searchable
              clearable
              maxDropdownHeight={200}
              nothingFound="No options"
            />
          </Grid.Col>
        ))}
      </Grid>
      <Group position="apart" mb="sm">
        <Text size="xs" color="dimmed">
          Showing {filteredCount} of {totalCount} funds
        </Text>
        {hasActiveFilters && (
          <Button
            variant="subtle"
            size="xs"
            compact
            onClick={() => onFilterChange(null)}
          >
            Clear filters
          </Button>
        )}
      </Group>
    </div>
  );
};

export default OrderArFormFundFilters;
